import type { ReactElement } from 'react';

import { Loading } from '@cntxt/shared/ui/feedback';

export default function RouteLoading(): ReactElement {
  return <Loading fullScreen source="auth/loading" />;
}
